import React, { useEffect, useState } from 'react';
import { Root, Portal, Overlay, Content } from '@radix-ui/react-dialog';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').Dialog}
 */
export const Dialog = ({
    animationDuration = 300,
    children,
    className,
    onOpenChange,
    open = false,
    warnBeforeClose,
}) => {
    const [animationOpen, setAnimationOpen] = useState(open);

    useEffect(() => {
        setAnimationOpen(open);
    }, [open]);

    const handleOpenChange = (open = false) => {
        setAnimationOpen(open);
        if (open) {
            onOpenChange(open);
        } else {
            setTimeout(() => onOpenChange(open), animationDuration);
        }
    };

    const handleWarning = (e) => {
        e.preventDefault();
        if (warnBeforeClose) {
            if (window.confirm(warnBeforeClose)) {
                handleOpenChange(false);
            }
        } else {
            handleOpenChange(false);
        }
    };

    return (
        <Root
            modal={true}
            onOpenChange={handleOpenChange}
            open={open}>
            <Portal>
                <Overlay className={`dialog__overlay${className ? ` ${className}` : ''} ${animationOpen ? 'dialog__overlay--open' : 'dialog__overlay--closed'}`}>
                    <Content
                        className='dialog__content'
                        onEscapeKeyDown={warnBeforeClose ? handleWarning : undefined}
                        onPointerDownOutside={warnBeforeClose ? handleWarning : undefined}>
                        {children}
                    </Content>
                </Overlay>
            </Portal>
        </Root>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Dialog;
